import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  AdministratorViewModel,
  PayrollReportHistoryRowViewModel,
  ReportingPeriodViewModel,
  ReportsRequestInput,
} from '@fora-monorepo/employer-my-pages-common/types';
import { trackException } from '@fora-monorepo/webapp-analytics';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';
import { mockAdministrators, mockPeriodForReportHistory, mockReportHistory } from './mocks/mockReportHistoryList';

export const getReportHistory = createAsyncThunk('getReportHistory', async (data: ReportsRequestInput, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockReportHistory;
  }

  const payload = {
    ...data,
  };

  return axios
    .post(`${envConfig.bffBaseUri}/payroll/reports`, payload)
    .then(res => {
      const reportHistory = res.data as PayrollReportHistoryRowViewModel[];
      return reportHistory;
    })
    .catch(err => {
      trackException(err);
      return thunkAPI.rejectWithValue(createThunkError('Could not get pay history', err));
    });
});

// TODO Do we need this? same as "getReportingPeriods"
export const getPeriodForReportHistory = createAsyncThunk(
  'getPeriodForReportHistory',
  async (data: { partnerNumberOrganization: string }, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockPeriodForReportHistory;
    }

    const payload = {
      ...data,
    };

    return axios
      .post(`${envConfig.bffBaseUri}/payroll/reporting-periods`, payload)
      .then(res => {
        if (res.status === 200) {
          const reportingPeriods = res.data as ReportingPeriodViewModel[];
          return reportingPeriods;
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get dates', err));
      });
  }
);

export const getAdministrators = createAsyncThunk(
  'getAdministrators',
  async (data: { partnerNumberOrganization: string }, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockAdministrators;
    }

    const payload = {
      ...data,
    };

    return axios
      .post(`${envConfig.bffBaseUri}/employer/administrators`, payload)
      .then(res => {
        if (res.status === 200) {
          const reportingPeriods = res.data as AdministratorViewModel[];
          return reportingPeriods;
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get dates', err));
      });
  }
);
